import { IAllUniversities } from './models';

function extractYouTubeVideoId(url?: string | null): string | undefined {
  const match = url?.match(/(?:\/embed\/|v=)([^?&]+)/);

  return match ? match[1] : undefined;
}

export const universitySchemaJson = (data: IAllUniversities, path: string) => ({
  '@context': 'https://schema.org/',
  '@type': 'CollegeOrUniversity',
  mainEntityOfPage: `https://akam.uz${path}`,
  name: data?.name,
  url: data?.site || `https://akam.uz${path}`,
  description: data?.description,
  image: data?.image,
  logo: data?.logo,
  telephone: data?.phone,
  numberOfStudents: data?.students_count,
  foundingDate:
    typeof data?.experience_years_count === 'number'
      ? String(new Date().getFullYear() - data?.experience_years_count)
      : undefined,
  address: {
    '@type': 'PostalAddress',
    streetAddress: data?.address,
    addressLocality: data?.map || 'Toshkent',
    addressCountry: 'UZ'
  },
  sameAs: [data?.instagram, data?.telegram, data?.youtube].filter(Boolean)
});

export const universityVideoSchemaJson = (data: IAllUniversities, path: string) => ({
  '@context': 'https://schema.org/',
  '@type': 'VideoObject',
  name: data?.name,
  description: data?.long_description,
  thumbnailUrl: `https://i.ytimg.com/vi/${extractYouTubeVideoId(data?.youtube_embed)}/hqdefault.jpg`,
  embedUrl: data?.youtube_embed,
  contentUrl: `https://akam.uz${path}`,
  isFamilyFriendly: true,
  uploadDate: '2025-06-06T00:00:00+05:00'
});
